export default {
    getPanoInfo: {
        result: {error: 0},
        'content': [

            {
                'feed_id': '19053',
                'strategy': 'strategy9',
                'reason': 'grade_high',
                'pid': '0901920012171115132418000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '',
                'address': '成都市-文殊院-说法堂',
                'type': '1',
                'tab_type': 6,
                'uid': '7388dffd41b17af2d3ff230f',
                'is_like': false,
                'topic': [
                    {
                        'id': '6948',
                        'name': '文殊院',
                        'type': 'uid',
                        'total': '62',
                        'order': 2
                    }
                ],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '说法堂',
                'uid_name': '文殊院',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0901920012171115132418000IN',
                'ext_info': []
            },
            {
                'feed_id': '1463858',
                'strategy': 'strategy9',
                'reason': 'grade_user',
                'pid': '1800220000140107122226307IN',
                'like_num': 125,
                'share_num': '71',
                'introduce': '经典电视剧《甄嬛传》中甄嬛出家至甘露寺部分的取景地。',
                'address': '北京市门头沟区永定镇京昆路',
                'type': '1',
                'tab_type': 6,
                'uid': 'df7c2341136f2e92841541b7',
                'is_like': false,
                'topic': [],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '北京戒台寺',
                'uid_name': '戒台寺',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=1800220000140107122226307IN',
                'ext_info': []
            },
            {
                'feed_id': null,
                'strategy': 'strategy9',
                'reason': 'topic',
                'pid': '22444400131907231563852361XX',
                'like_num': 0,
                'share_num': 0,
                'introduce': '',
                'address': '',
                'type': 0,
                'tab_type': 12,
                'uid': '',
                'is_like': false,
                'topic': [],
                'view_dir': null,
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '',
                'uid_name': null,
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=',
                'ext_info': {
                    'topic_id': '8507',
                    'name': '尖子班',
                    'total': '11',
                    'type': 'uid',
                    'distance': 0,
                    'recom': [
                        {
                            'pid': '22444400131908141565748136XX',
                            'pano_name': '外景'
                        },
                        {
                            'pid': '22444400131908141565748139XX',
                            'pano_name': '喷泉'
                        },
                        {
                            'pid': '22444400131908141565748144XX',
                            'pano_name': '绿化'
                        },
                        {
                            'pid': '22444400131908141565748149XX',
                            'pano_name': '一层大堂'
                        },
                        {
                            'pid': '22444400131908141565748158XX',
                            'pano_name': '一层电梯间'
                        },
                        {
                            'pid': '22444400131908141565748174XX',
                            'pano_name': '独栋样板间一层'
                        }
                    ],
                    'like_num': 0
                }
            },
            {
                'feed_id': '34571',
                'strategy': 'strategy9',
                'reason': 'grade_high',
                'pid': '22444400131908161565921277XX',
                'like_num': 0,
                'share_num': '0',
                'introduce': '盘龙一路天纵城附近',
                'address': '武汉市-一凡儿童游乐园(天纵城)-售票处',
                'type': '2',
                'tab_type': 6,
                'uid': '8ac52e1adc9a9b21d42ce2f6',
                'is_like': false,
                'topic': [],
                'view_dir': '123,-11.19',
                'content_type': 0,
                'heading': '123',
                'pitch': '-11.19',
                'pano_name': '售票处',
                'uid_name': '一凡儿童游乐园(天纵城)',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=22444400131908161565921277XX',
                'ext_info': []
            },
            {
                'feed_id': '57544',
                'strategy': 'strategy9',
                'reason': 'grade_user',
                'pid': '22444400132005091707263726XX',
                'like_num': 76,
                'share_num': '35',
                'introduce': '孔林占地近200万平方米，有坟冢10万余座，有神道与城门相连。孔子墓位于孔林中部，封土呈偃斧形，汉代设祠坛建神门，宋代刻制石仪，元代立碑、作周垣、建重门，明代重建享殿墓门、添建洙水桥坊和万古长春坊。孔林丰富的地上文物，对于研究中国墓葬制度的沿革和古代政治、经济、文化、风俗、书法、艺术等都具有很高的价值。',
                'address': '济宁市-孔林-孔子墓',
                'type': '2',
                'tab_type': 6,
                'uid': '9f97b1c547728f07b64f540a',
                'is_like': false,
                'topic': [
                    {
                        'id': '7497',
                        'name': '孔林',
                        'type': 'uid',
                        'total': '15',
                        'order': 2
                    }
                ],
                'view_dir': '142.41,2.76',
                'content_type': 0,
                'heading': '142.41',
                'pitch': '2.76',
                'pano_name': '孔子墓',
                'uid_name': '孔林',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=22444400132005091707263726XX',
                'ext_info': []
            },
            {
                'feed_id': '20565',
                'strategy': 'strategy9',
                'reason': 'grade_high',
                'pid': '0800020000141219174549536UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '',
                'address': '武汉市-古德寺-古德寺(古德寺路)-古德寺流通处',
                'type': '1',
                'tab_type': 6,
                'uid': 'd5464cf884a8aa57fda778fe',
                'is_like': false,
                'topic': [
                    {
                        'id': '7982',
                        'name': '古德寺',
                        'type': 'uid',
                        'total': '23',
                        'order': 2
                    }
                ],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '古德寺流通处',
                'uid_name': '古德寺',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800020000141219174549536UZ',
                'ext_info': []
            },
            {
                'feed_id': '220509',
                'strategy': 'strategy9',
                'reason': 'grade_user',
                'pid': '09004800122003110946172183O',
                'like_num': 11974,
                'share_num': '2',
                'introduce': '广东省广州市越秀区北京路315号',
                'address': '',
                'type': '0',
                'tab_type': 6,
                'uid': '',
                'is_like': false,
                'topic': [],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '',
                'uid_name': '',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=09004800122003110946172183O',
                'ext_info': []
            },
            {
                'feed_id': '17017',
                'strategy': 'strategy9',
                'reason': 'grade_high',
                'pid': '0901800012170729144454000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '',
                'address': '晋中市-渾漆齋大院-清虚观-太平兴国观1',
                'type': '1',
                'tab_type': 6,
                'uid': 'bcaebff88fe4a455c9e33c0b',
                'is_like': false,
                'topic': [
                    {
                        'id': '7602',
                        'name': '渾漆齋大院',
                        'type': 'uid',
                        'total': '245',
                        'order': 2
                    }
                ],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '太平兴国观1',
                'uid_name': '渾漆齋大院',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0901800012170729144454000IN',
                'ext_info': []
            },
            {
                'feed_id': '163437',
                'strategy': 'strategy9',
                'reason': 'grade_high',
                'pid': '0801170000140927103742293UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '',
                'address': '沈阳市-沈阳故宫博物馆-沈阳故宫-明清钟表展',
                'type': '1',
                'tab_type': 6,
                'uid': 'a52a9af0586ffd4a9dec2bec',
                'is_like': false,
                'topic': [],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '明清钟表展',
                'uid_name': '沈阳故宫博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0801170000140927103742293UZ',
                'ext_info': []
            },
            {
                'feed_id': '543064',
                'strategy': '',
                'reason': 'supply',
                'pid': '0102420000140327223233060IN',
                'like_num': 1341,
                'share_num': '936',
                'introduce': '香港特别行政区湾仔区黄泥涌道',
                'address': '',
                'type': '1',
                'tab_type': '',
                'uid': '',
                'is_like': false,
                'topic': [],
                'view_dir': '',
                'content_type': 0,
                'heading': 0,
                'pitch': 0,
                'pano_name': '',
                'uid_name': '',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0102420000140327223233060IN',
                'ext_info': []
            }
        ]
    },
    voteSharePano: {
        result: {
            error: 0,
            msg: 'ok'
        },
        content: true
    },
    getfeedextral: {
        result: {
            error: 0,
            msg: 'ok'
        },
        content: {
            music_list: [
                'https://map-yunying.cdn.bcebos.com/%20map-yunying/red-song-map/caidanzhuoma.mp3',
                'http://www.w3school.com.cn/i/horse.mp3',
                'http://pano2bucket.cdn.bcebos.com/6d531199ddd9acbdda57033536920264'
            ],
            feed_popup: [{
                title: '感觉今天推荐内容怎么样？',
                id: 1,
                btn: [
                    {
                        type: 0,
                        text: '很有趣'
                    },
                    {
                        type: 1,
                        text: '没意思'
                    }
                ]

            }],
            feed_content: [
                {
                    type: 0,
                    text: '图片质量差'
                },
                {
                    type: 1,
                    text: '音乐不好听'
                },
                {
                    type: 2,
                    text: '推荐不准确'
                },
                {
                    type: 3,
                    text: '经常重复推荐'
                },
                {
                    type: 4,
                    text: '内容很无聊'
                }
            ]
        }
    },
    getFeedByTopic: {
        result: {
            error: 0,
            msg: 'ok'
        },
        content: [
            {
                'feed_id': '28072',
                'strategy': '',
                'pid': '0900250001161220152442000IN',
                'like_num': 1,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-售票处',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': 'uid'
                    }
                ],
                'pano_name': '售票处',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220152442000IN'
            },
            {
                'feed_id': '28073',
                'strategy': '',
                'pid': '0900250001161220140527000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝帝都',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': 'city'
                    }
                ],
                'pano_name': '六朝帝都',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220140527000IN'
            },
            {
                'feed_id': '28074',
                'strategy': '',
                'pid': '0900250001161220140856000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝木桩遗迹',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝木桩遗迹',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220140856000IN'
            },
            {
                'feed_id': '28075',
                'strategy': '',
                'pid': '0900250001161220140249000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝瓦当',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝瓦当',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220140249000IN'
            },
            {
                'feed_id': '28076',
                'strategy': '',
                'pid': '0900250001161220141416460IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝衣食',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝衣食',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220141416460IN'
            },
            {
                'feed_id': '28077',
                'strategy': '',
                'pid': '0900250001161220141807000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-土墙遗迹',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '土墙遗迹',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220141807000IN'
            },
            {
                'feed_id': '28078',
                'strategy': '',
                'pid': '0900250001161220140025000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-遗址展示厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '遗址展示厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220140025000IN'
            },
            {
                'feed_id': '28079',
                'strategy': '',
                'pid': '0900250001161220141154000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-居家陈设',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '居家陈设',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220141154000IN'
            },
            {
                'feed_id': '28080',
                'strategy': '',
                'pid': '0900250001161220151942000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-大厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '大厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220151942000IN'
            },
            {
                'feed_id': '28081',
                'strategy': '',
                'pid': '0800250000140826232943005UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-1912民都荟',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '1912民都荟',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232943005UZ'
            },
            {
                'feed_id': '28082',
                'strategy': '',
                'pid': '0800250000140826232935727UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-展播厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '展播厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232935727UZ'
            },
            {
                'feed_id': '28083',
                'strategy': '',
                'pid': '0900250001161220133923000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-东方大都会',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '东方大都会',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220133923000IN'
            },
            {
                'feed_id': '28084',
                'strategy': '',
                'pid': '0800250000140826232939809UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-回望六朝',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '回望六朝',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232939809UZ'
            },
            {
                'feed_id': '28085',
                'strategy': '',
                'pid': '0900250001161220135714480IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-回望六朝展厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '回望六朝展厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220135714480IN'
            },
            {
                'feed_id': '28086',
                'strategy': '',
                'pid': '0900250001161220133102000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-记里鼓车',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '记里鼓车',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220133102000IN'
            },
            {
                'feed_id': '28087',
                'strategy': '',
                'pid': '0900250001161220134514890IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-礼乐秀群英',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '礼乐秀群英',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220134514890IN'
            },
            {
                'feed_id': '28088',
                'strategy': '',
                'pid': '0800250000140826232935892UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232935892UZ'
            },
            {
                'feed_id': '28089',
                'strategy': '',
                'pid': '0800250000140826232939591UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝人杰',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝人杰',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232939591UZ'
            },
            {
                'feed_id': '28090',
                'strategy': '',
                'pid': '0900250001161220133533000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝三百秋',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝三百秋',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220133533000IN'
            },
            {
                'feed_id': '28091',
                'strategy': '',
                'pid': '0800250000140826232943090UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝沙盘',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝沙盘',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232943090UZ'
            },
            {
                'feed_id': '28092',
                'strategy': '',
                'pid': '0800250000140826232939740UZ',
                'like_num': 1,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝书法',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝书法',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232939740UZ'
            },
            {
                'feed_id': '28093',
                'strategy': '',
                'pid': '0800250000140826232939556UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝瓦当',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝瓦当',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232939556UZ'
            },
            {
                'feed_id': '28094',
                'strategy': '',
                'pid': '0800250000140826232943679UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-青瓷',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '青瓷',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232943679UZ'
            },
            {
                'feed_id': '28095',
                'strategy': '',
                'pid': '0800250000140826232940054UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-青瓷的色彩变幻',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '青瓷的色彩变幻',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232940054UZ'
            },
            {
                'feed_id': '28096',
                'strategy': '',
                'pid': '0800250000140826232943903UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-石门',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '石门',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232943903UZ'
            },
            {
                'feed_id': '28097',
                'strategy': '',
                'pid': '0900250001161220135425000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-丝路通四海',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '丝路通四海',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220135425000IN'
            },
            {
                'feed_id': '28098',
                'strategy': '',
                'pid': '0900250001161220134113000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-至今秦淮上',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '至今秦淮上',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220134113000IN'
            },
            {
                'feed_id': '28099',
                'strategy': '',
                'pid': '0800250000140826232943124UZ',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-贝氏建筑走廊',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '贝氏建筑走廊',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0800250000140826232943124UZ'
            },
            {
                'feed_id': '28100',
                'strategy': '',
                'pid': '0900250001161220145953550IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-冬谷枯荣',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '冬谷枯荣',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220145953550IN'
            },
            {
                'feed_id': '28101',
                'strategy': '',
                'pid': '0900250001161220142338000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-画廊',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '画廊',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220142338000IN'
            },
            {
                'feed_id': '28102',
                'strategy': '',
                'pid': '0900250001161220145543000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-绘画',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '绘画',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220145543000IN'
            },
            {
                'feed_id': '28103',
                'strategy': '',
                'pid': '0900250001161220142553000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝风采厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝风采厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220142553000IN'
            },
            {
                'feed_id': '28104',
                'strategy': '',
                'pid': '0900250001161220144909000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-棋盘',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '棋盘',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220144909000IN'
            },
            {
                'feed_id': '28105',
                'strategy': '',
                'pid': '0900250001161220142743000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-青瓷的色彩1',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '青瓷的色彩1',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220142743000IN'
            },
            {
                'feed_id': '28106',
                'strategy': '',
                'pid': '0900250001161220143148000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-青瓷的色彩2',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '青瓷的色彩2',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220143148000IN'
            },
            {
                'feed_id': '28107',
                'strategy': '',
                'pid': '0900250001161220144206000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-石麒麟',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '石麒麟',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220144206000IN'
            },
            {
                'feed_id': '28108',
                'strategy': '',
                'pid': '0900250001161220145234000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-书法',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '书法',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220145234000IN'
            },
            {
                'feed_id': '28109',
                'strategy': '',
                'pid': '0900250001161220144609000IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-塑像',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '塑像',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220144609000IN'
            },
            {
                'feed_id': '28110',
                'strategy': '',
                'pid': '0900250001161220150851050IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-展厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '展厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220150851050IN'
            },
            {
                'feed_id': '28111',
                'strategy': '',
                'pid': '0900250001161220151516330IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-画展厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '画展厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220151516330IN'
            },
            {
                'feed_id': '28112',
                'strategy': '',
                'pid': '0900250001161220150315580IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-六朝人杰展厅',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '六朝人杰展厅',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220150315580IN'
            },
            {
                'feed_id': '28113',
                'strategy': '',
                'pid': '0900250001161220150536620IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-孙权像',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '孙权像',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220150536620IN'
            },
            {
                'feed_id': '28114',
                'strategy': '',
                'pid': '0900250001161220151157800IN',
                'like_num': 0,
                'share_num': '0',
                'introduce': '六朝博物馆位于南京市玄武区汉府街、东箭道以东、长江路以北，是中国展示六朝文物最全面的遗址博物馆，也是反映六朝文化最系统的专题博物馆。展出青瓷器、陶俑、墓志、建筑构件、石刻、书画等大量珍贵文物以及六朝建康城城墙和大型排水设施遗迹，并介绍六朝名人故事，分四个篇章阐述公元3至6世纪的东方大都会主题，设有“六朝帝都”、“回望六朝”、“六朝风采”、“六朝人杰”四大展厅。',
                'address': '南京市-六朝博物馆-祖冲之像',
                'type': '1',
                'uid': '6cdd6c03b678c6dfb5147fd6',
                'is_like': false,
                'topic': [
                    {
                        'id': '3423',
                        'name': '六朝博物馆',
                        'type': '2'
                    }
                ],
                'pano_name': '祖冲之像',
                'imgurl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=120&height=200&panoid=0900250001161220151157800IN'
            }
        ]
    }

};